import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { T } from "@repo/transifex";
import { MembersGridLayout } from "~/components/collect/members-grid";
import { SearchPageLayout } from "~/components/search-page-layout";
import { employeeActions } from "~/providers/store/employee";
import { useDebounce } from "~/hooks/use-debounce";
import { useGetChildrenSearch } from "~/api/children/hooks/use-get-children-search";

export const PosChildrenSearchPage = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const debounceSearch = useDebounce((query: string) => {
    setSearchQuery(query);
  }, 250);

  const { data, isFetching, isError, refetch } = useGetChildrenSearch({
    search: searchQuery
  });

  return (
    <SearchPageLayout
      onBack={() => {
        navigate(-1);
      }}
      isLoading={isFetching}
      isError={isError}
      data={data}
      onSearch={debounceSearch}
      onRetry={refetch}
      renderItem={(item) => (
        <MembersGridLayout.Link
          to="/pos/sell"
          member={item.name}
          key={item.id}
          onClick={() => {
            employeeActions.setAuthEmployee({
              employeeChildId: item.id,
              groupName: item.groupName
            });
          }}
        />
      )}
      emptyStateMessage={<T _str="Start typing to search for a user..." />}
      noResultsMessage={<T _str="No users found. Try adjusting your search." />}
    />
  );
};
